/* React-обвязка сервиса заказа: одно состояние React повторяет снимок сервиса, эффекты — реакции бывшего useStudioForm
   в прежнем порядке и с прежними зависимостями.
   Снимок попадает в React через useState: изменившиеся в set() ключи уходят тем же вызовом и в том же месте кода, что и
   прежние setState, поэтому приоритет и момент рендера прежние. useSyncExternalStore рендерил бы каждое изменение
   синхронно в микрозадаче, раньше продолжения ожидающего действия: эффект «Попробовать ещё раз» увидел бы форму до
   retrying = true (retry()), и новый заказ не создавался бы, а useTailRetry отправлял бы заказ раньше markSeen и order-clear. */
import { useEffect, useLayoutEffect, useState } from 'react';
import { bindOrderCtx, createOrderService, hookView, mergeSnapshot, type OrderCtx, type OrderService, type StudioFormView } from './order-service';

export function useOrderService(o: OrderCtx): { svc: OrderService; view: StudioFormView } {
  /* Сервис не пересоздаётся (бывший хук тоже хранил состояние при смене app.id) */
  const [svc] = useState(() => createOrderService(o));
  const [first] = useState(svc.get);
  const [s, setSnapshot] = useState(first);
  /* Рендер считает и действует на своих пропсах; svc.ctx (для действий движка) обновляется при фиксации рендера */
  const d = svc.derive(s, o);
  useLayoutEffect(() => bindOrderCtx(svc, o));
  /* since = first: то, что изменилось до подписки (эффекты детей идут раньше), приходит сразу; без изменений React не рендерит */
  useLayoutEffect(() => svc.subscribe((_, changed) => setSnapshot(current => mergeSnapshot(current, changed)), first), [svc, first]);
  useEffect(() => svc.reactions.owner(o.app.id), [svc, o.app.id]);
  useEffect(() => svc.reactions.form(o.app.id, o.avatar, s.revision, o.initialInputs), [svc, o.app.id, o.avatar, s.revision, o.initialInputs]);
  useEffect(() => svc.reactions.quote(d.quoteEndpoint, d.quoteBody), [svc, d.quoteEndpoint, d.quoteBody]);
  useEffect(() => svc.reactions.poll(d.orderId, d.terminal), [svc, d.orderId, d.terminal]);
  useEffect(() => svc.reactions.mount(), [svc]);
  useEffect(() => svc.reactions.revoke(s.result), [svc, s.result]);
  useEffect(() => {
    svc.reactions.retryTick({ s, d, ctx: o });
    // submit берётся из текущего рендера: форма и входы уже восстановлены returnToForm.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [s.form, d.orderId, s.busy, s.intent]);
  return { svc, view: hookView(svc, s, d, o) };
}
